import { OFFER_TYPES } from "../constants/offerTypes";
import { SORTS } from "../constants/sorts";
import { getEntities } from "./base";

function path(sort) {
  if (sort === SORTS.popular) {
    return "/portal/api/propositions/popular";
  } else {
    return "/portal/api/propositions";
  }
}

const getPropositions = (
  clientConfig,
  dataStatus,
  filter,
  sort,
  offerType,
  withDetails
) => {
  let isSimOnly = false;
  let limits = { ...clientConfig.limits };

  if (offerType === OFFER_TYPES.simOnly) {
    limits.brandId = [];
    limits.phoneId = [];
    limits.phoneOperatingSystemId = [];
    limits.phoneVariantId = [];
    isSimOnly = true;
  }

  filter = { ...filter, isSimOnly: isSimOnly };

  return getEntities(
    clientConfig,
    dataStatus,
    path(sort),
    null,
    { offerType: offerType, withDetails: withDetails },
    limits,
    filter
  );
};

export { getPropositions };
